import React from 'react';
import { Switch } from 'react-router';
import { Route } from 'react-router-dom';
import { Config } from '~admin/config';
import { Paths } from '~admin/route';
import { AuthRoute } from '~admin/route/auth-route.component';
import { TestRouter } from '~admin/view/components/__tests__/test-router.component';
import { ToolContainer } from '~admin/view/components/core/tool-container.component';
import { LoginPage } from '~admin/view/pages/auth/login.page';
import { LogoutPage } from '~admin/view/pages/auth/logout.page';
import { NotFound } from '~common/components/core/not-found.component';
import { QueryRoute } from '~common/route/query-route';

export const AppContainer: React.FunctionComponent = () => {
  return (
    <Switch>
      <QueryRoute exact path={Paths.login} component={LoginPage} />
      <Route exact path={Paths.logout} component={LogoutPage} />
      <Route path={Paths.test} component={Config.enableTestPaths ? TestRouter : NotFound} />
      <AuthRoute path={Paths.tool.base} component={ToolContainer} />
      <Route component={NotFound} />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./view/components/app-container.component.tsx